import { Component, computed, inject, model, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  ICerrarCajaRes,
  ICierreCajaReq,
} from '@core/interfaces/request-response/caja.dto.interface';
import { FormField, form, maxLength, min, required } from '@angular/forms/signals';
import { UiProgressSpinner, UiTooltip } from '@shared/components/ui';
import { CajaTurnoApiService } from '@core/services/api/caja-turno.service';
import { ToastService } from '@shared/services/toast.service';
import { FormErrorMessagePipe } from '../../pipes/form-error-message.pipe';

@Component({
  selector: 'app-cuadre-cierre',
  standalone: true,
  imports: [CurrencyPipe, FormField, UiProgressSpinner, DatePipe, FormErrorMessagePipe, UiTooltip],
  templateUrl: './cuadre-cierre.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cuadre-cierre.css',
})
export class CuadreCierre implements OnInit {
  // servicios
  private cajaTurnoService = inject(CajaTurnoApiService);
  private toastService = inject(ToastService);
  // datos
  datos = model<ICerrarCajaRes | undefined>(undefined);
  cerrar = output<boolean>();
  form = form(
    signal({
      monto: 0,
      descripcion: '',
    }),
    (x) => {
      required(x.monto, { message: 'El monto es requerido' });
      required(x.descripcion, { message: 'La descripción es requerida' });
      min(x.monto, 0, { message: 'El monto no puede ser negativo' });
      maxLength(x.descripcion, 125, {
        message: 'La descripción no puede tener más de 125 caracteres',
      });
    },
  );
  diferencia = computed(() => {
    return (
      this.form().controlValue().monto -
      (this.datos()?.efectivo_esperado ?? this.datos()?.monto_cierre_efectivo ?? 0)
    );
  });

  private markAllAsTouched() {
    this.form.monto().markAsTouched();
    this.form.descripcion().markAsTouched();
  }
  private checkInvalidForm() {
    if (this.form().invalid()) {
      this.markAllAsTouched();
      this.toastService.show(
        'top-right',
        'error',
        'Error',
        'Por favor, corrija los errores en el formulario',
      );
      return true;
    }
    return false;
  }
  // metodos
  onCancelar() {
    this.cerrar.emit(false);
  }
  onAceptar() {
    if (this.checkInvalidForm()) return;
    const { monto, descripcion } = this.form().controlValue();
    const req: ICierreCajaReq = {
      monto_cierre_reportado: monto,
      motivo_cierre_reportado: descripcion,
    };
    this.cajaTurnoService.cerrar(req).subscribe({
      next: () => {
        this.toastService.show('top-right', 'success', 'Éxito', 'Caja cerrada correctamente');
        this.cerrar.emit(true);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err.error.message || 'Error al cerrar la caja',
        );
      },
    });
  }

  ngOnInit(): void {
    this.cajaTurnoService.cuadrarCaja().subscribe({
      next: (res) => {
        this.datos.set(res);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err.error.message || 'Error al obtener los datos para el cuadre de caja',
        );
      },
    });
  }
}